import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: false,        // Disable raw HTML input for safety
  linkify: true,      // Auto-convert URL-like text to links
  typographer: true   // Enable smart quotes and other typographic replacements
});

/**
 * Renders a markdown string to safe HTML.
 * Returns an empty string for null, undefined, or empty input.
 * 
 * @param {string} markdownString - The markdown content to render
 * @returns {string} The rendered HTML string
 */
export function renderMarkdown(markdownString) {
  if (!markdownString || typeof markdownString !== 'string') {
    return '';
  }

  return md.render(markdownString);
}
